export enum LegendItemDirection {
  COLUMN = 'column',
  ROW = 'row',
}

export enum LegendLocation {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  TOP = 'TOP',
}
